import type { Routes } from '../views/Routes';
import type { NativeStackScreenProps } from '@react-navigation/native-stack';
import StyledText from '../components/StyledText';

type Props = NativeStackScreenProps<Routes, 'CameraPage'>;
export default function CameraComponent({ navigation }: Props) {
    return (<StyledText>Not available</StyledText>)
}
